import i18n from "@/i18n";
import toast from "@/plugins/toast";
import router from "../router/index";
import { State } from "@/store/state";
import { Request } from "@/network/request";
// import Vue from "vue";
export default class auth {
  endPoint = "login";
  token = null;

  loginState = new State();

  async login(payload) {
    let request = new Request({
      method: "post",
      endpoint: `/${this.endPoint}`,
      data: payload,
    });

    await this.loginState.trigger(
      async () => {
        return await request.send();
      },
      {
        onSuccess: (value) => {
          this.token = value.token;
          localStorage.setItem("token", value.token);
          localStorage.setItem("admin_type", value.admin.type);
          if (value.admin.type == "branch")
            localStorage.setItem("branch", JSON.stringify(value.admin.branch));
          this.token = true;
          router.push("/courses");
          toast(
            i18n.t("login success"),
            { timeout: 4000, rtl: true },
            "sucess"
          );
        },
        onError: (error) => {
          toast(i18n.t(error.type), { timeout: 4000, rtl: true }, "error");
        },
      }
    );
  }
  logout() {
    localStorage.removeItem("NoteLang");
    localStorage.removeItem("token");
    localStorage.removeItem("abilities");
    router.push("/login");
    toast(i18n.t("logout success"), { timeout: 4000, rtl: true }, "sucess");
  }
}

export const Auth = new auth();
